export const citiesV2TableHead = [
  {
    id: 'title.main',
    numeric: true,
    disablePadding: false,
    label: 'Name',
    sortable: true,
  },
  {
    id: 'governorate.title.main',
    numeric: true,
    disablePadding: false,
    label: 'Governorate',
    sortable: false,
  },
  {
    id: 'district.title.main',
    numeric: true,
    disablePadding: false,
    label: 'District',
    sortable: false,
  },
  {
    id: 'subDistrict.title.main',
    numeric: true,
    disablePadding: false,
    label: 'Subdistrict',
    sortable: false,
  },
  {
    id: 'code',
    numeric: true,
    disablePadding: false,
    label: 'Code',
    sortable: true,
  },
  {
    id: 'isActive',
    numeric: true,
    disablePadding: false,
    label: 'Status',
    sortable: false,
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'Actions',
    sortable: false,
  },
];

export interface initialErrorsType {
  [key: string]: any;
}

export const initialErrors: initialErrorsType = {
  title: null,
};

export const CITY_V2_STATUS_OPTIONS = [
  { value: 'ALL', labelKey: 'All' },
  { value: 'true', labelKey: 'Active' },
  { value: 'false', labelKey: 'Inactive' },
];
